import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { app } from "./firebase";
import "./fonts/SVNGilroy-Bold.otf";
import "./fonts/SVNGilroy-Light.otf";
import { createTheme, ThemeProvider } from "@mui/material";

const firebaseApp = app;
const rootElement = document.getElementById("root");
const root = ReactDOM.createRoot(document.getElementById("root"));
const theme = createTheme({
    props: {
        // Name of the component ⚛️
        MuiInputBase: {
            disableRipple: true,
        },
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true,
            },
        },
    },
    typography: {
        fontFamily: "SVNGilroy",
    },
    components: {
        MuiPopover: {
            defaultProps: {
                container: rootElement,
            },
        },
        MuiPopper: {
            defaultProps: {
                container: rootElement,
            },
        },
        MuiDialog: {
            defaultProps: {
                container: rootElement,
            },
        },
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true,
            },
        },
        MuiDrawer: {
            defaultProps: {
                container: rootElement,
            },
        },
        MuiLocalizationProvider: {
            defaultProps: {
                localeText: {
                    cancelButtonLabel: "Hủy",
                    okButtonLabel:'Đồng ý'
                },
            },
        },
    },
});
root.render(
    <ThemeProvider theme={theme}>
        <App />
    </ThemeProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
